import { render, staticRenderFns } from "./v-signup-price.vue?vue&type=template&id=11aeafc5&scoped=true&"
import script from "./v-signup-price.vue?vue&type=script&lang=js&"
export * from "./v-signup-price.vue?vue&type=script&lang=js&"
import style0 from "./v-signup-price.vue?vue&type=style&index=0&id=11aeafc5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11aeafc5",
  null
  
)

export default component.exports